import React, {Fragment, useMemo} from "react";
import {NavLink} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import ContextMenu from "../Utils/ContextMenu";
import classes from "./styles.module.css";

function TableRow({data, contracts, terminals}) {
    const status = () => {
        if (!data || data.status === undefined) return <div className={classes.Disabled}><FormattedMessage
            id="PcaTable.status.inactive" defaultMessage="Не активен"/></div>;
        switch (data.status) {
            case 0:
                return <div className={classes.Disabled}><FormattedMessage id="PcaTable.status.inactive"
                                                                           defaultMessage="Не активен"/></div>;
            case 1:
                return <div className={classes.Process}><FormattedMessage id="PcaTable.status.inProgress"
                                                                          defaultMessage="Обрабатывается"/></div>;
            case 2:
                return <div className={classes.Enables}><FormattedMessage id="PcaTable.status.paid"
                                                                          defaultMessage="Выплачено"/></div>;
            case 3:
                return <div className={classes.Error}><FormattedMessage id="PcaTable.status.declined"
                                                                        defaultMessage="Платеж отклонен"/></div>;
            case 4:
                return <div className={classes.Error}><FormattedMessage id="PcaTable.status.error"
                                                                        defaultMessage="Ошибка"/></div>;
            default:
                return <div className={classes.Disabled}><FormattedMessage id="PcaTable.status.inactive"
                                                                           defaultMessage="Не активен"/></div>;
        }
    };

    const contract = useMemo(
        () => (contracts ? contracts.find((c) => c && c.id === (data && data.psaContractId)) : null),
        [contracts, data]
    );
    const provider = useMemo(
        () => (terminals ? terminals.find((t) => t && t.uuid === (data && data.providerId)) : null),
        [terminals, data]
    );

    return (
        <Fragment>
            <tr className={classes.Row}>
                <td>{(data && data.id) || ""}</td>
                <td>{(data && data.name) || ""}</td>
                <td>{contract ? contract.name : ""}</td>
                <td>{provider ? provider.displayName : ""}</td>
                <td>{(data && data.date) || ""}</td>
                <td>{(data && data.amount) || ""}</td>
                <td>{status()}</td>
                <td className={classes.CellMenu}>
                    <ContextMenu icon="menu">
                        <ul>
                            <li className={classes.MenuItem}>
                                <NavLink className={classes.ActivateLink} to={`/metal/pca/${(data && data.id) || ""}`}>
                                    <FormattedMessage id="PcaTable.menu.view" defaultMessage="Просмотр ПСА"/>
                                </NavLink>
                            </li>
                            <li className={classes.MenuItem}>
                                <NavLink className={classes.defaultLink}
                                         to={`/metal/pca/duplicate/${(data && data.id) || ""}`}>
                                    <FormattedMessage id="PcaTable.menu.duplicate" defaultMessage="Дублировать ПСА"/>
                                </NavLink>
                            </li>
                        </ul>
                    </ContextMenu>
                </td>
            </tr>
        </Fragment>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/PcaTable/TableRow.js